import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { ResponsiveImage } from "@quintype/components";

import "./PartnershipSection.m.css";

const PartnershipSection = ({ titleElement, galleryElement, useBrandColour = false }) => {
  const title = get(titleElement, ["text"], "In partnership with");
  const partnerImages = get(galleryElement, ["story-elements"], []);

  if (!partnerImages || partnerImages.length === 0) {
    return null;
  }

  return (
    <div styleName={`partnership-section ${useBrandColour ? "brand-colour-section" : ""}`}>
      <div styleName="partnership-title">{title}</div>
      <div styleName="partners-row">
        {partnerImages.map((image, index) => {
          const imageKey = get(image, ["image-s3-key"], "");
          const imageMetadata = get(image, ["image-metadata"], {});
          const altText = get(image, ["alt-text"], "Partner logo");

          if (!imageKey) return null;

          return (
            <div key={image.id || index} styleName="partner-logo">
              <ResponsiveImage
                slug={imageKey}
                metadata={imageMetadata}
                aspectRatio={[4, 1]}
                defaultWidth={124}
                widths={[124, 248]}
                imgParams={{ auto: ["format", "compress"] }}
                alt={altText}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

PartnershipSection.propTypes = {
  titleElement: PropTypes.object,
  galleryElement: PropTypes.object,
  useBrandColour: PropTypes.bool,
};

export default PartnershipSection;
